import { render, staticRenderFns } from "./VistoriaNewEdit.vue?vue&type=template&id=d06c4ffe&"
import script from "./VistoriaNewEdit.vue?vue&type=script&lang=js&"
export * from "./VistoriaNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports